// src/components/Partenaires.jsx
// ─────────────────────────────────────────────────────────────
// Bloc « Nos partenaires », partagé par la page Devis et l'accueil.
//
// Pour ajouter un partenaire : une entrée dans PARTENAIRES ci-dessous,
// sa présentation en français et en anglais dans `textes` (sous le même
// nom), et son logo dans public/images/.
// ─────────────────────────────────────────────────────────────
import React from 'react';
import './Partenaires.css';
import { useTextes } from '../i18n/Langue';

export const PARTENAIRES = [
  {
    nom: 'G-Events',
    lien: 'https://www.instagram.com/g_events_g?igsh=MWJxa2NtcTB1Yzg4MQ%3D%3D&utm_source=qr',
    logo: 'logo-gevents.jpeg',
    // Le logo G-Events est sur fond sombre, celui de Be On Wall sur fond clair
    fond: 'dark',
  },
  {
    nom: 'Be On Wall',
    lien: 'https://www.beonwall.com',
    logo: 'logo-bow.jpeg',
    fond: 'light',
  },
];

/* Textes : la présentation de chaque partenaire est rangée sous son nom */
const textes = {
  fr: {
    label: '✦ Sublimez votre soirée',
    sousTitre: 'Nos partenaires recommandés pour une expérience inoubliable',
    presentations: {
      'G-Events': {
        description: 'Photobooth, vidéobooth 360°, livre d’or audio, artifices & panneau welcome',
        cta: 'Voir sur Instagram →',
      },
      'Be On Wall': {
        description: 'Photos & messages de vos invités en direct sur grand écran',
        cta: 'Visiter le site →',
      },
    },
  },
  en: {
    label: '✦ Make your event shine',
    sousTitre: 'Partners we recommend for an unforgettable experience',
    presentations: {
      'G-Events': {
        description: 'Photo booth, 360° video booth, audio guest book, sparklers & welcome sign',
        cta: 'See on Instagram →',
      },
      'Be On Wall': {
        description: 'Your guests’ photos & messages live on the big screen',
        cta: 'Visit the website →',
      },
    },
  },
};

function Partenaires({ className = '', showHeader = true, label, sousTitre }) {
  const t = useTextes(textes);
  return (
    <div className={`partners-section ${className}`.trim()}>
      {showHeader && (
        <div className="partners-header">
          <span className="partners-label">{label || t.label}</span>
          <p className="partners-sub">{sousTitre || t.sousTitre}</p>
        </div>
      )}

      <div className="partners-grid">
        {PARTENAIRES.map((p) => (
          <a
            key={p.nom}
            href={p.lien}
            target="_blank"
            rel="noreferrer"
            className="partner-card"
          >
            <div className={`partner-logo-wrap partner-logo-wrap--${p.fond}`}>
              <img
                src={`${process.env.PUBLIC_URL}/images/${p.logo}`}
                alt={p.nom}
                className="partner-logo"
                loading="lazy"
              />
            </div>
            <div className="partner-info">
              <h4 className="partner-name">{p.nom}</h4>
              <p className="partner-desc">{t.presentations[p.nom].description}</p>
              <span className="partner-cta">{t.presentations[p.nom].cta}</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default Partenaires;
